import { FC } from 'react';
import { userStore } from '@modules/user/adapter/outbound/stores/user.store';
import { mapDefaultProfileImageByGender } from '@shared/helpers/mapDefaultProfileImage.helper';
import { ProfileImg } from './ProfileImage.style';
const ProfileImageLogic: FC = () => {
  const {
    userDetail
  } = userStore(state => state);
  return userDetail && <ProfileImg src={userDetail.profileImage || mapDefaultProfileImageByGender(userDetail.gender)} alt="profile image" width={120} height={120} onError={({
    currentTarget
  }) => {
    currentTarget.onerror = null; // prevents looping
    currentTarget.src = mapDefaultProfileImageByGender(userDetail.gender);
  }} />;
};
export default ProfileImageLogic;